import React from 'react';

const Logo = () => {
    return (
        <div className="c-logo">M Room</div>
    );
};

export default Logo;